import { Outlet, useNavigate } from 'react-router-dom';
import React, { useState } from 'react'
import { sidebarData } from './Super_Sidebar'
import DashboardSidebar from '../../layout/Sidebar/Sidebar';

const SuperAdminDashboard = () => {
  const [isexpand, setExpanded] = useState(false);
  return (
    <>
      <div className="dashboard-main-section">
        <DashboardSidebar sidebarData={sidebarData} isexpand={isexpand} setExpanded={setExpanded} />
        <div className={isexpand ? "dashboard-main-content-sectionn" : "dashboard-main-content-sectionnn"}>
          <Outlet />
        </div>
      </div>
    </>
  );
};


export default SuperAdminDashboard
